import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { MenuItem, Select } from '@mui/material';

import { FormattedValue } from '../store/formatted-value';
import { Group } from '../organisms/group';
import { SwitchBox } from '../molecules/switch-box';
import { ControlBox } from '../atoms/control-box';
import { useSelector } from '../store/utils';
import { StatusDot } from '../atoms/status-dot';
import { get } from 'lodash';
import { relayControlTypeLabels } from '../organisms/relay-options-select';
import { ParentPaper } from '../atoms/parent-paper';
import { RelaySettingsValue } from '../templates/settings/relay-settings-value';
import { RelaySummary, RelaySummary15Min } from '../molecules/relay-summary';
import { SpotPricePeriod } from '../../../core/src/shared/enums';

const RelayPage = () => {
  const [relayIndex, setRelayIndex] = useState(0);

  const spPricePeriod = useSelector((s) => s.variables.SP_PRICE_PERIOD);

  const [
    relayOutputs,
    relayNames,
    relayControlTypes,
    relayEnabled,
    morePlugsEnabled,
    thermostatInstall,
  ] = useSelector(
    ({ variables }) =>
      [
        variables.RELAY_OUTPUT,
        variables.RELAY_NAME,
        get(variables, 'RELAY_CONTROL_TYPE[0]'),
        variables.RELAY_ENABLED,
        get(variables, 'PL_MORE_PLUGS_NUMBER') > 3,
        variables.THERMOSTAT_INSTALL,
      ] as const
  );

  const relayIsActive = relayOutputs.map((status, index) => ({
    id: index,
    isActive: status,
  }));

  return (
    <>
      <Group layout="list">
        <ControlBox
          title={<FormattedMessage id="relay.title" defaultMessage="Relé" />}
          fullWidth
          control={
            <Select
              value={relayIndex}
              onChange={(e) => setRelayIndex(e.target.value as number)}
            >
              {Array(4)
                .fill(null)
                .map((_, i) => {
                  return relayEnabled[i] ? (
                    <MenuItem value={i} key={i}>
                      {relayNames[i]}
                    </MenuItem>
                  ) : null;
                })
                .filter(Boolean)}
            </Select>
          }
        />

        <ControlBox
          title={
            <FormattedMessage id="relay.status" defaultMessage="Sepnuto" />
          }
          control={<StatusDot alive={relayIsActive[relayIndex].isActive} />}
          fullWidth
          visibility={{ variableId: `RELAY_ENABLED[${relayIndex}]` }}
        />
      </Group>
      <Group
        title={
          <FormattedMessage id="relay.main" defaultMessage="Obecné informace" />
        }
        layout="list"
      >
        <SwitchBox
          title={
            <FormattedMessage id="relay.name" defaultMessage="Název relé" />
          }
          subtitle={<FormattedValue variableId={`RELAY_NAME[${relayIndex}]`} />}
          fullWidth
        />
        {(spPricePeriod === SpotPricePeriod['60M'] ||
          spPricePeriod === SpotPricePeriod['15M']) && (
          <RelaySummary relayIndex={relayIndex} />
        )}
        {spPricePeriod === SpotPricePeriod['15M'] && (
          <RelaySummary15Min relayIndex={relayIndex} />
        )}
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="relay.condition"
                defaultMessage="Podmínka spínání"
              />
            }
            subtitle={relayControlTypeLabels[relayControlTypes[relayIndex]]}
            fullWidth
            visibility={{ variableId: `RELAY_ENABLED[${relayIndex}]` }}
          />
          <RelaySettingsValue index={relayIndex} />
        </ParentPaper>
      </Group>
    </>
  );
};

export default RelayPage;
